import { ImSpinner8 } from "react-icons/im";
import { MdRestaurantMenu } from "react-icons/md";
import { TbBolt, TbBuilding, TbCoffee, TbCurrentLocation, TbHome, TbMapPin, TbMapPinStar, TbMapPinX, TbMapSearch, TbPlaneDeparture, TbSignRight, TbStar } from "react-icons/tb";

//* Google Tag Manager
export const REACT_APP_GTM_ID = 'GTM-TFKRMSTM';
export const TAG_MANAGER_ARGS = {
    gtmId: REACT_APP_GTM_ID,
}

//* Icons 
export const ADDRESS_TYPE_HOME = 'Casa';
export const ADDRESS_TYPE_WORK = 'Trabalho';
export const ADDRESS_TYPE_OTHER = 'Outro';
export const ADDRESS_TYPE_LOCALE = 'locale';
export const ADDRESS_TYPE_NOT_LISTED = 'notListed';
export const ADDRESS_TYPE_STORE_LIST = 'storeList';
export const ADDRESS_TYPE_SAVED = 'customer';
export const ADDRESS_TYPE_LOADING = 'loading';

export const ALL_STATES = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

export const getIconAddress = (type: string, size:number = 20) => {
    switch(type) {
        case ADDRESS_TYPE_HOME:
            return <TbHome size={size} />;
        case ADDRESS_TYPE_LOADING:
            return <ImSpinner8 className="animate-spin text-custom-primary" size={Number(size - 2)} />;
        case ADDRESS_TYPE_WORK:
            return <TbCoffee size={size} />;
        case ADDRESS_TYPE_OTHER:
            return <TbStar size={size} />;
        case ADDRESS_TYPE_LOCALE:
            return <TbCurrentLocation size={size} />;
        case ADDRESS_TYPE_NOT_LISTED:
            return <TbMapPinX size={size} />;
        case ADDRESS_TYPE_STORE_LIST:
            return <TbMapSearch size={size} />;
        case ADDRESS_TYPE_SAVED:
            return <TbMapPinStar size={size} />;
        default:
            return <TbMapPin size={size} />;
    }
}

export const STORE_TYPE_AIRPORT = 1;
export const STORE_TYPE_SHOPPING = 2;
export const STORE_TYPE_EXPRESS = 3;
export const STORE_TYPE_STREET = 4;
export const STORE_TYPE_RESTAURANT = 5;

export const getIconByStoreType = (type: number, size:number = 20) => {
    switch(type) {
        case STORE_TYPE_AIRPORT:
            return <TbPlaneDeparture size={size} />;
        case STORE_TYPE_SHOPPING:
            return <TbBuilding size={size} />;
        case STORE_TYPE_EXPRESS:
            return <TbBolt size={size} />;
        case STORE_TYPE_STREET:
            return <TbSignRight size={size} />;
        case STORE_TYPE_RESTAURANT:
            return <MdRestaurantMenu size={size} />;
        default:
            return null;
    }
}


export const PROFILE_GENDER_MALE = 1;
export const PROFILE_GENDER_FEMALE = 2;
export const PROFILE_GENDER_OTHER = 3;

export const getProfileGenderLabel = (gender: number) => {
    switch (gender) {
        case PROFILE_GENDER_MALE:
            return 'Masculino'
        case PROFILE_GENDER_FEMALE:
            return 'Feminino'
        case PROFILE_GENDER_OTHER:
            return 'Outro'
        default:
            return '';
    }
}

export const getProfileGenderList = () => {
    return [
        {type:  PROFILE_GENDER_MALE, label: getProfileGenderLabel(PROFILE_GENDER_MALE)},
        {type:  PROFILE_GENDER_FEMALE, label: getProfileGenderLabel(PROFILE_GENDER_FEMALE)},
        {type:  PROFILE_GENDER_OTHER, label: getProfileGenderLabel(PROFILE_GENDER_OTHER)},
    ]
}

export const AUTHENTICATION_TYPE_LOGIN = 'login';
export const AUTHENTICATION_TYPE_SSO = 'SSO';
